import React from 'react';

const Loader: React.FC = () => {
    return (
        <div
            style={{
                position: "fixed", // Position it over everything else
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 1, 0.01)",  // Dark semi-transparent background
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,  // Ensure it's on top of other content
                backdropFilter: "blur(5px)",  // Apply a blur effect to the content below
                opacity: 1,  // Full opacity when visible
                transition: "opacity 0.5s ease-out",  // Smooth fade-out effect
            }}
            data-testid="loader-container"
        >
            <svg
                version="1.1"
                id="L9"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 100 100"
                enableBackground="new 0 0 100 100"
                xmlSpace="preserve"
                width="50px"
                height="50px"
                data-testid="loader-svg"
            >
                <circle
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="4"
                    strokeLinecap="round"
                    cx="50"
                    cy="50"
                    r="40"
                    data-testid="loader-circle"
                />
                <circle
                    fill="none"
                    stroke="#000000"
                    strokeWidth="4"
                    strokeLinecap="round"
                    cx="50"
                    cy="50"
                    r="40"
                    transform="rotate(219.421 50 50)"
                    strokeDasharray="126.92 126.92"
                    strokeDashoffset="63.46"
                    data-testid="loader-circle-2"
                >
                    <animate
                        attributeName="stroke-dashoffset"
                        dur="1.2s"
                        repeatCount="indefinite"
                        from="0"
                        to="502"
                        data-testid="loader-animate"
                    />
                </circle>
            </svg>
        </div>
    );
};

export default Loader;
